module.exports = __webpack_public_path__ + "img/b-hero-vagas-abertas.005eb039.jpg";